import { ReduxHelper } from "helpers";
import {
  ICreateUserRequest,
  IDeleteByIdRequest,
  IGetAllUsersResponse,
  IGetByIdRequest,
  IPaginationRequest,
  IUpdateUserRequest,
  IUser,
} from "model";

export const prefix = "USER";

export const getAllUsers = ReduxHelper.generateActions<
  IPaginationRequest,
  IGetAllUsersResponse
>(prefix, "GET_ALL_USERS");

export const getUserById = ReduxHelper.generateActions<IGetByIdRequest, IUser>(
  prefix,
  "GET_USER_BY_ID"
);
export const createUser = ReduxHelper.generateActions<
  ICreateUserRequest,
  IUser
>(prefix, "CREATE_USER");
export const updateUser = ReduxHelper.generateActions<
  IUpdateUserRequest,
  IUser
>(prefix, "UPDATE_USER");
export const changePasswordUser = ReduxHelper.generateActions<
  IUpdateUserRequest,
  IUser
>(prefix, "CHANGE_PASSWORD_USER");
export const deleteUser = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  { id: string }
>(prefix, "DELETE_USER");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
